import Loc from "../../Loc/Loc";

export default class Affaire {
    public id: number;
    public libelle: string;
    public completeName: string;
    public daClient: string;
    public commandeClient: string;

    public constructor() {
        this.id = -1;
        this.libelle = Loc.trad().RecepDocsContractsAll;
        this.completeName = "";
        this.daClient = "";
        this.commandeClient = "";
    }
}